import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useUserThemeContext } from "../../context/userThemeContext";
import Header from "../header/Header";
import "./Home.scss";

const Home = () => {
  const { showHeader, setShowHeader } = useUserThemeContext();
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (position.x <= 15) {
      setShowHeader(true);
    }
  }, [position]);

  useEffect(() => {
    setShowHeader(false);
  }, []);

  useEffect(() => {
    const updateMousePosition = (event: MouseEvent) => {
      setPosition({ x: event.clientX, y: event.clientY });
    };
    window.addEventListener("mousemove", updateMousePosition);
    return () => window.removeEventListener("mousemove", updateMousePosition);
  }, []);

  return (
    <div className="config-dashboard main-container flex h-full w-full">
      <div
        className={`config-dashboard__header overflow-hidden transition-all duration-300 ease-in-out ${showHeader ? "w-[4.5rem] px-[0.62rem] opacity-100" : "w-0 opacity-0"} py-2`}
        style={{
          background:
            "linear-gradient(180deg, #090E17 0%, #090E16 3.88%, #010101 100%)",
        }}
        onMouseLeave={() => setShowHeader(false)}
        onMouseEnter={() => setShowHeader(true)}
      >
        <Header />
      </div>
      <div
        className={`config-dashboard__outlet transition-all duration-300 ease-in-out ${showHeader ? "w-[calc(100%-4.5rem)]" : "w-full"} overflow-hidden`}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default Home;
